import React from 'react';
import { useEffect } from 'react';
import Layout from '../../Layout/Layout';
import { Row, Col, Container, Form, Input, InputGroupText, Spinner, Button } from 'reactstrap';
import TitleBar from '../../Layout/TitleBar';
import {
  MealsSearchCriteriaInputType,
  useTranslator,
  CookbookMealSearchEdge,
} from '@front-activerse/common-components';
import { useState } from 'react';
import CookbookMealItem from '../components/CookbookMealItem';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { useOutletContext } from 'react-router-dom';
import { useAppContext } from '@front-activerse/common-components';

interface ICookbookSearchContainer {
  search: {
    searchCookbookMeals: (searchCriteria?: MealsSearchCriteriaInputType) => Promise<any>;
    loading: boolean;
    meals: CookbookMealSearchEdge[];
    called: boolean;
  };
  addToFavorites: (mealId: number) => Promise<unknown>;
  removeFromFavorites: (mealId: number) => Promise<unknown>;
}

export const CookbookSearchContainer: React.FC<ICookbookSearchContainer> = ({
  search,
  addToFavorites,
  removeFromFavorites,
}) => {
  const { t } = useTranslator();
  const locationFromUseLocation = useLocation();
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  const {
    images: { searchIcon, noSearchResultsIcon, searchButton },
  } = useAppContext();

  const { trackFirebaseEvent } = useOutletContext<{
    trackFirebaseEvent: (eventName: string, eventPayload: object) => void;
  }>();
  const searchQuery = queryString.parse(locationFromUseLocation.search).q;

  useEffect(() => {
    if (searchQuery) {
      setSearchValue(searchQuery as string);
      search.searchCookbookMeals({ query: searchQuery as string });
    }
  }, [searchQuery]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (searchValue) {
      // await search.searchCookbookMeals({ query: searchValue });
      trackFirebaseEvent('user_action', {
        action: 'search',
        location: 'Dietplan',
        meals_tab: 'cookbook',
      });
      navigate(`/meals/cookbook/search?q=${searchValue}`, { replace: true });
    }
  };

  return (
    <Layout>
      <TitleBar level={1}>{t('cookbook.search.navbarTitle')}</TitleBar>
      <div className="page-template-cookbook full-height3">
        <Container className="py-md-4">
          <Row>
            <Col md={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <Row>
                  <Col md={{ size: 8, offset: 2 }}>
                    <div className="search-container">
                      <Form onSubmit={handleSubmit} className="d-flex">
                        <div className="input-group-with-addon start flex-grow-1">
                          <InputGroupText>
                            <img src={searchIcon} alt="search" />
                          </InputGroupText>
                          <Input
                            id="search"
                            name="search"
                            type="search"
                            enterkeyhint="search"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            placeholder={t('meal.search.inputPlaceholder')}
                          />
                          <Button type="submit" color="primary" size="sm" className="ms-2 px-m">
                            <img src={searchButton} alt="search" />
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </Col>
                </Row>

                <div className="search-result-container">
                  {search.loading && (
                    <div className="text-center mb-xl">
                      <Spinner color="primary" size="sm" className="me-2">
                        {t('loading.message')}
                      </Spinner>
                      <p className="d-inline-block mb-0 text-text-variant-color">
                        {t('cookbook.searchResipe.searchingResipesLoading.content')}
                      </p>
                    </div>
                  )}
                  {search.meals.length > 0 && (
                    <>
                      <h2 className="title-medium semi-bold mb-m">
                        {t('meal.searchResults.title')}
                      </h2>
                      <Row className="cookbook-meals">
                        {search.meals.map((edge) => (
                          <CookbookMealItem
                            key={edge.node.id}
                            {...edge.node}
                            addToFavorites={addToFavorites}
                            removeFromFavorites={removeFromFavorites}
                            orientation="horizontal"
                          />
                        ))}
                      </Row>
                    </>
                  )}

                  {search.called && search.meals?.length === 0 && !search.loading && (
                    <>
                      <h2 className="title-medium semi-bold mb-m">
                        {t('meal.searchResults.title')}
                      </h2>
                      <div className="text-center pt-xl">
                        <img
                          src={noSearchResultsIcon}
                          width={64}
                          height={64}
                          className="mb-m"
                          alt=""
                        />
                        <p className="text-text-variant-color mb-m">
                          {t('meal.searchResults.noResultsContent')}
                        </p>
                        <p className="text-text-variant-color">
                          {t('meal.searchResults.noResultsAdditionalContent')}
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default CookbookSearchContainer;
